<template>
    <div class="introduction-area">
        <div class="report-section">

            <div class="sub-area" v-if="cropperiodData">

                <div class="report-title title mb-0">
                    <div class="block-text">
                        安邦
                        <i class="fa fa-heart mr-0"></i>
                        未遲
                    </div>
                    愛情全紀錄
                </div>

                <div class="section-title">
                    <div class="section-sub-title">{{ cropperiodData.project_name }}</div>
                    <div class="section-sub-title">{{ cropperiodData.name }}</div>
                </div>
                <br>

                <b-row align-h="center">
                    <b-col lg=10>

                        <!-- 品種 -->
                        <!-- <h2 class="title">
                            <div class="block-text">
                                安邦
                                <i class="fa fa-heart mr-0"></i>
                                未遲
                            </div>
                        </h2> -->

                        <div>

                            <!-- 期作圖片 -->
                            <img class="report-pic"
                                src="./logo.png"
                                alt="cropperiods photo" >
                        </div>

                    </b-col>

                    <b-col lg=12>

                        <div>
                            <!-- 種植日期 -->
                            <h4>
                                <i class="fa fa-calendar block-title"></i>
                                <div class="block-text">開始交往日：</div>
                                <div class="block-text">2020-05-20</div>
                                <i class="fa fa-minus"></i>
                                <div class="block-text">2022-09-24</div>
                            </h4>

                            <!-- 敘述 -->
                            <div class="tab-block-body intro-description" v-if="cropperiod_description">
                                <p v-for="(paragraph, idx) in cropperiod_description" :key="idx">
                                    {{ paragraph }}
                                    <span v-if="paragraph">。</span>
                                </p>
                            </div>
                        </div>

                    </b-col>

                    <b-col lg=12>

                        <h2 class="title">什麼是愛情全紀錄 ?</h2>

                        <div class="tab-block intro-description">
                            <p>
                                「 愛情全紀錄 」是未遲與邦邦的日記，從愛情的種子落地後直至採收，每天的互動、情緒以及一起經歷的所有事情，都對關係產生影響，造就了今日的我們。
                            </p>
                            <p>
                                在這裡，你可以看見我們的關係中的點點滴滴，以及在日常生活中我們如何用心相愛、照顧彼此。
                            </p>
                            <p>
                                所謂愛情，則沐浴其中，欣欣向榮、亭亭玉立。
                            </p>
                        </div>

                        <!-- Print & Share Link -->
                        <!-- <div class="block-text print-hide-object">
                            <BtnCopyToClipboard :copy_content="getReportURL"
                                                :btn_text="$t('menu.copy_report_link')"
                                                :btn_style="'big'" :btn_variant="'outline-warning'" :show_tooltip="false">
                            </BtnCopyToClipboard>
                            <BtnSavePDF v-if="user != undefined && user.id != undefined && getToken != undefined"
                                        :save_id="'print-page-top'"
                                        :save_type="'PDF'"
                                        :save_filename="report_save_name"
                                        :save_url="report_url"
                                        :save_preview="false"
                                        :log_detail="getLogDetail"
                                        :copy_content="report_url" :btn_text="$t('menu.download')"
                                        btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false">
                            </BtnSavePDF>
                            <BtnCopyToClipboard v-if="user_admin"
                                                :copy_content="getDeIdentificationURL"
                                                :btn_text="'複製簡易去識別化報告網址 (Admin)'"
                                                :btn_style="'big'" :btn_variant="'outline-warning'" :show_tooltip="false">
                            </BtnCopyToClipboard>
                        </div> -->

                    </b-col>
                </b-row>
            </div>

            <!-- <div class="sub-area">
                <h3>農夫有話要說</h3>
                <b-row align-v="center">
                    <b-col cols=12 :xl="speech_col" v-for="(speech, idx_speech) in speechData" :key="idx_speech">

                        <PersonSpeech   :avatar="speech.avatar"
                                        :name="speech.name"
                                        :content="speech.content"
                        ></PersonSpeech>

                    </b-col>
                </b-row>
            </div>

            <div class="sub-area">
                <h3>阿龜說故事</h3>
            </div> -->

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import PersonSpeech from '@/views/project/report/Period_1.0/components/PersonSpeech'
import BtnCopyToClipboard from '@/views/components/Button_CopyToClipboard'
import BtnSavePDF from '@/views/components/Button_SavePDF'

export default {
    props: {
        cropperiodData: {
            type: Object,
            required: true,
        },
    },
    components: {
        PersonSpeech,
        BtnCopyToClipboard,
        BtnSavePDF,
    },
    data () {
        return {
            speechData: [
                {
                    name: 'Black Sugar',
                    avatar: 'https://storage.googleapis.com/turtwig-cloud-storage/avatars/7a7bb396-f023-44d0-8190-37143d81bdf8.png?0.7342029378624858',
                    content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. ",
                },
                {
                    name: 'Cola',
                    avatar: 'https://storage.googleapis.com/turtwig-cloud-storage/avatars/b453e3d2-c3de-49e7-b20a-a7d1359a6636.png',
                    content: "I'm a cat. ",
                },
            ]


        }
    },
    mounted ()
    {

    },
    computed: {
        ...mapState({
            'user_language': state => state.user.language,
            'user_admin': state => state.user.is_admin,
        }),

        getReportURL ()
        {
            // let _url = this.$route.path + '?id=' + this.$route.query.id
            // if ( this.user_language ) _url += '&lang=' + this.user_language

            let _path = {
                name: this.$route.name,
                query: {
                    id:     this.$route.query.id,   // 一般網址
                    ids:    this.$route.query.ids,  // 去識別化網址
                    lang:   this.user_language,
                    format: this.$route.query.format,
                },
            }
            let _url = location.origin + this.$router.resolve( _path ).href

            return _url
        },

        getDeIdentificationURL ()
        {
            return this.getReportURL.replace('?id=', '?ids=')
        },

        speech_col ()
        {
            if ( this.speechData.length > 1 ) return 6
            return 12
        },

        cropperiod_description ()
        {
            let _origin = this.cropperiodData.description
            if ( _origin != undefined )
            {
                let _descriptions = _origin.split('。')
                return _descriptions
            }
            return undefined
        },
    },
    methods: {

    },

}
</script>

<style lang="scss" scoped>

.introduction-area
{
    color: #716664;//rgb(186, 186, 186);
    // background-color: rgba(118, 58, 78, 1);
    // background-color: rgb(32, 49, 56);
    background-color: #f8dcd9; //rgb(105, 30, 54);
}

.section-sub-title
{
    color: #716664;
}

.reports-style-period-1 .tab-block-body
{
    color: #527b99;
    background-color: #fef4f2;
}

.report-title
{
    text-align: center;
    color: rgba(186, 186, 186, 0.8);
    font-size: 1.2rem;
}

.title
{
    margin-top: 5px;
    margin-bottom: 15px;
    color: #d19f42;
}

.intro-description
{
    font-size: 1.2rem;
}

.report-logo
{
    width: 200px;
    height: auto;
    max-height: 80px;
}

.report-pic
{
    width: 180%;
    border-radius: 5px;
    // background-color:  rgba(79, 79, 79, 0.2);
    // margin-top: 5px;
    margin-bottom: -20%;
    margin-top: -45%;
    margin-left: -38%;
}

.print-hide-object
{
    margin: 10px 0px 60px 0px;
}

</style>
